import { EMS_TYPE } from '@hems/util/src/constant';
import { deviceInfoSorter } from '@hems/util/src/helper/deviceHelper';
import { ENERGY_MANAGEMENT_ACTION } from '@hems/util/src/stores/modules/energyManagement';
export const initState = {
    deviceList: [],
    masterDeviceInfo: null,
    hubInfo: null,
};
const prefix = 'site';
export const SITE_ACTION = {
    SET_DEVICE_LIST: `${prefix}/setDeviceList`,
    SET_HUB_INFO: `${prefix}/setHubInfo`,
    CLEAR: `${prefix}/clear`,
};
export default {
    namespaced: true,
    state: { ...initState },
    mutations: {
        setMasterDeviceInfo(state, payload) {
            state.masterDeviceInfo = payload;
        },
        setDeviceList(state, payload) {
            state.deviceList = payload.sort(deviceInfoSorter);
        },
        setHubInfo(state, payload) {
            state.hubInfo = payload;
        },
        clear(state) {
            state.deviceList = [];
            state.hubInfo = null;
        },
    },
    actions: {
        setDeviceList({ commit, dispatch }, payload) {
            commit('setDeviceList', payload);
            if (payload.length <= 1) {
                const [device = null] = payload;
                commit('setMasterDeviceInfo', device);
                dispatch(ENERGY_MANAGEMENT_ACTION.SET_SITE_ID, device?.deviceInfo.site_id ?? null, { root: true });
                dispatch(ENERGY_MANAGEMENT_ACTION.SET_PRODUCT_MODEL_NAME, device?.deviceInfo.product_model_nm ?? '', {
                    root: true,
                });
                dispatch(ENERGY_MANAGEMENT_ACTION.SET_MASTER_DEVICE_ID, device?.deviceInfo.device_id ?? '', { root: true });
                return;
            }
            const primaryACDeviceInfo = payload.find((device) => device.deviceInfo.ems_type_cd === EMS_TYPE.PRIMARY);
            const standAloneACDeviceInfo = payload.find((device) => device.deviceInfo.ems_type_cd === EMS_TYPE.STAND_ALONE);
            const masterDeviceInfo = primaryACDeviceInfo ?? standAloneACDeviceInfo ?? null;
            commit('setMasterDeviceInfo', masterDeviceInfo);
            dispatch(ENERGY_MANAGEMENT_ACTION.SET_SITE_ID, masterDeviceInfo?.deviceInfo.site_id ?? null, { root: true });
            dispatch(ENERGY_MANAGEMENT_ACTION.SET_PRODUCT_MODEL_NAME, masterDeviceInfo?.deviceInfo.product_model_nm ?? '', {
                root: true,
            });
            dispatch(ENERGY_MANAGEMENT_ACTION.SET_MASTER_DEVICE_ID, masterDeviceInfo?.deviceInfo.device_id ?? '', {
                root: true,
            });
        },
        setHubInfo({ commit }, payload) {
            commit('setHubInfo', payload);
        },
        clear({ commit }) {
            commit('clear');
        },
    },
};
